import { render } from "./natoGroupClass.vue?vue&type=template&id=17131c56"
import script from "./natoGroupClass.vue?vue&type=script&lang=js"
export * from "./natoGroupClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__